import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import {
  IEnergyConsumptionFlexeservePanel,
  ITrendPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import TrendPanel from '../../../../../../../../theme/ui/Dashboard/TrendPanel/TrendPanel';

export interface EnergyConsumptionFlexeservePanelProps {
  panel: IEnergyConsumptionFlexeservePanel;
  layout?: LayoutItem | undefined;
}

function EnergyConsumptionFlexeservePanel(
  props: EnergyConsumptionFlexeservePanelProps
) {
  const { panel, layout } = props;
  // Example: 24 data points per day for 7 days (168 values)
  const mock24x7Values = Array.from({ length: 7 * 24 }, (_, i) => {
    // Simulate a daily pattern with some randomness
    const hour = i % 24;
    const base = 1100 + (hour >= 6 && hour <= 18 ? 300 : 100); // Higher during day
    return base + Math.round(Math.random() * 100);
  });

  const labelValuePanel: ITrendPanel = {
    type: 'TREND',
    id: `energy_consumption_flexeserve`,
    title: panel.title,
    subtitle: panel.subtitle,
    sparkLineProps: {
      data: mock24x7Values,
    },
  };
  return <TrendPanel panel={labelValuePanel} layout={layout} />;
}

export default EnergyConsumptionFlexeservePanel;
